import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 12.998h-6v6h-2v-6H5v-2h6v-6h2v6h6z",
  fill: "currentColor"
}));
export default SvgPlus;